import e from"styled-components";import{COLORS as i}from"../../constants/Theme.js";import{BodyTiny as t,TitleSmall as o}from"../TypographyStyle.js";import{ScreenName as n}from"./modal.js";const r=e.div`
	display: flex;
	background-color: white;
	height: ${e=>e.renderWithoutModal?"90%":"75vh"};
	flex-direction: column;
`,d=e.div`
	overflow-y: scroll;
	overflow-x: hidden;

	::-webkit-scrollbar {
		display: block;
		width: 8px;
	}

	::-webkit-scrollbar-thumb {
		background-color: ${e=>e.screenName!==n.RearrangeProducts?"#888":"#fff"};
		border-radius: 8px;
	}
`,l=e.div`
	height: 64px;
	background-color: ${e=>e.isDisabled?"#F0F0F0":e.isActive?i.background.positive.light:"white"};
	border-bottom: 1px solid #e0e0e0;
	padding: ${e=>e.usedInSearch?"12px 16px":"12px 24px"};
	display: flex;
	flex-direction: row;
	column-gap: 16px;
	justify-content: space-between;
	align-items: center;
	:hover {
		cursor: pointer;
		background-color: ${i.surface.hovered};
	}
`,p=e.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	column-gap: 18px;
`,a=e.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`,c=e.div`
	display: flex;
	flex-direction: row;
	max-height: 32px;
	min-height: 32px;
	background-color: ${i.background.base};
	justify-content: flex-start;
	align-items: center;
	padding: 8px 16px;
	margin-top: 16px;
	position: sticky;
	top: 0;
	z-index: 10;
`,s=e.div`
	display: flex;
	flex-direction: row;
	column-gap: 16px;
	padding: 12px 16px;
	border-bottom: 1px solid #e0e0e0;
	align-items: center;
`,x=e.div`
	min-height: 64px;
	background-color: ${e=>e.isActive?i.background.positive.light:"white"};
	border-bottom: 1px solid #e0e0e0;
	padding: 12px 16px;
	display: flex;
	flex-direction: row;
	column-gap: 16px;
	justify-content: flex-start;
	align-items: center;
	padding-left: ${e=>e.isVariant?"42px":"16px"};
	:hover {
		cursor: pointer;
		background-color: ${i.surface.hovered};
	}
`,g=e.div`
	display: flex;
	flex-direction: row;
	max-height: 32px;
	min-height: 32px;
	background-color: ${i.background.base};
	justify-content: flex-start;
	align-items: center;
	padding: 8px 16px;
	position: sticky;
	top: 0;
	z-index: 10;
`,f=e.div`
	display: flex;
	flex-direction: column;
`,h=e.div`
	min-height: 72px;
	background: white;
	padding: 12px 16px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;

	.text-container {
		display: flex;
		gap: 16px;
		flex: 1;
	}

	.tooltip-title-tag {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		gap: 16px;
	}
	.info-container {
		display: flex;
		flex-direction: column;
		flex: 1;
	}
`,m=e.div`
	height: 72px;
	width: 72px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 16px;
`;e.div`
	display: flex;
	width: 32px;
	height: 32px;
	padding: 6px;
	justify-content: center;
	align-items: center;
	border: 1px solid ${i.stroke.primary};
	border-radius: 4px;
`;const u=e.div`
	padding: 16px 24px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: auto;
	width: 100%;
`,b=e.div`
	width: fit-content;
	background: ${i.background.brandLight};
	padding: 2px 6px;
	border-radius: 14px;
`,y=e(t)`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 196px;
	display: block;
	color: ${i.background.inverseLight};
`,w=e.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 5px;
`,v=e.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	min-width: 0;
`;e(o)`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
`;export{a as CollectionCardDetailStyle,p as CollectionCardInfoStyle,l as CollectionCardStyle,f as CollectionNameHolder,r as ContainerStyle,y as EllipsedBodyTiny,x as ProductCardStyle,v as ProductInfo,s as ProductScreenCollectionCardStyle,c as ProductScreenHeader,w as ProductSubTitle,b as SKUIDBadge,d as ScrollContainerStyle,g as SelectedScreenHeader,u as StyledFooterForNonModal,m as VariantCardGridStyle,h as VariantCardListStyle};
